import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/main/Home';
import EssayDetector from './components/main/EssayDetector';
import People from './components/classroom/People';
import Assignment from './components/classroom/Assignments';
import Classroom from './components/classroom/Classroom';
import ClassPage from './components/classroom/ClassPage';
import Pricing from './components/main/Pricing';
import Signup from './components/auth/Signup';
import Login from './components/auth/Login';
import PublicHistory from './components/main/PublicHistory';
import PrivateRoute from './components/utils/PrivateRoute';
import { onAuthStateChanged } from 'firebase/auth';
import { collection } from 'firebase/firestore';
import { auth, db } from './config/firebase';
import { query, where, getDocs } from 'firebase/firestore';
import Educator from './components/main/Educator';
import MobileHistory from './components/main/MobileHistory';

import AnalyticsPage from './components/classroom/AnalyticsPage';
import PlagiarismChecker from './components/main/PlagiarismChecker';
import CollegeDashboard from './components/classroom/CollegeDashboard';
import TeacherDashboard from './components/classroom/TeacherDashboard';
import StudentDashboard from './components/classroom/StudentDashboard';
import JoinClassroom from './components/classroom/JoinClassroom';
import ClassroomSignupLogin from './components/classroom/ClassroomSIgnupLogin';
import Proctoring from './components/classroom/Proctoring';
import VivaSystem from './components/classroom/VivaBot';
import PrivacyPolicy from './components/main/PrivacyPolicy';
import TermsOfService from './components/main/TermsOfService';
import CookiePolicy from './components/main/CookiePolicy';


const App = () => {
  const [userName, setUsername] = useState('');
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        const usersCollectionRef = collection(db, 'users');
        try {
          const q = query(usersCollectionRef, where('uid', '==', uid));
          const querySnapshot = await getDocs(q);
          querySnapshot.forEach((doc) => {
            setUsername(doc.data().username); // Assuming 'username' is the field with user's name
          });
        } catch (error) {
          console.error('Error fetching user documents:', error);
        }
      }
    });
    return () => unsubscribe();
  }, []);
  
  return (
    <Router>
      <Routes>
        {/* normal routes */}
        <Route path="/" element={<Home />} />
        <Route path="/essay-detector" element={<PrivateRoute element={EssayDetector} />} />
        <Route path="/classroom" element={<PrivateRoute element={Classroom} />} />
        <Route path="/pricing" element={<PrivateRoute element={Pricing} />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/token/:username?/:tokenid?" element={<PublicHistory />} />
        <Route path="/history" element={<MobileHistory username={userName} visible={true} />} />
        <Route path="/plagiarism" element={<PlagiarismChecker />} /> 

        {/* classroom routes */}
        <Route path="/classpage" element={<ClassPage />} />
        <Route path="/viva" element={<VivaSystem />} />
        <Route path="/test" element={<Proctoring />} />
        <Route path="/educator" element={<Educator />} />
        <Route path="/analytics" element={<AnalyticsPage/>} />
        <Route path="/people" element={<People />} />
        <Route path="/assignment" element={<Assignment />} />
        <Route path="/:collegeId" element={<CollegeDashboard />} />
        <Route path="/teacher/:collegeId" element={<TeacherDashboard />} />
        <Route path="/student/:collegeId" element={<StudentDashboard />} />
        <Route path="/join/:collegeId/:classroomId" element={<JoinClassroom />} />
        <Route path="/education/signin" element={<ClassroomSignupLogin />} /> 

        {/* Privacy Policy */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/termsofservice" element={<TermsOfService />} />
        <Route path="/cookiepolicy" element={<CookiePolicy />} />

      </Routes>
    </Router>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
